var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flow-chart-one",attrs:{"id":"flow-chart-one","width":"1100","height":"1400"}}),_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }